














import { Vue, Component } from 'vue-property-decorator';
import EnvioComandosSMS from '@/pantallas/TorreControl/EnvioComandosSMS/EnvioComandosSMS.vue';

@Component({
  components: { EnvioComandoComponent: EnvioComandosSMS },
})
export default class EnvioComandosSMSPantalla extends Vue {}
